import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  style: {
    width: "100%",
  },

  form: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    flexDirection: "column",
    //
    width: "100%",
  },

  wrapup: {
    minWidth: "100%", // default maximum width
    [theme.breakpoints.down("sm")]: {
      maxWidth: "400px",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },

  divider: {
    width: "100%",
    alignItems: "center",
    color: "#B7B7B7",
  },
  dividerText: {
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
